import script from "./infection-phase-events.vue?vue&type=script&setup=true&lang=ts"
export * from "./infection-phase-events.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__